// Swatches

window.changeProduct = function (swatch) {
  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  card.querySelectorAll('.swatch').forEach(s => s.removeAttribute('active'));
  swatch.setAttribute('active', '');

  const mediaContainer = card.querySelector('.media--hover-effect');
  if (mediaContainer) {
    // Collect all image URLs from swatch data attributes
    const imageUrls = [];
    let index = 0;
    while (swatch.dataset[`img${index}`]) {
      imageUrls.push(swatch.dataset[`img${index}`]);
      index++;
    }

    // Get all existing images (both visible and in carousel)
    const images = mediaContainer.querySelectorAll('img');

    // Update the original images (they might be hidden if carousel exists)
    images.forEach((img, idx) => {
      if (imageUrls[idx]) {
        img.src = imageUrls[idx];
        img.srcset = imageUrls[idx];
      }
    });

    // Check if there's a carousel and rebuild it
    const existingCarousel = mediaContainer.querySelector('.product-images-carousel');
    if (existingCarousel && window.innerWidth <= 1024) {
      // Remove old carousel
      existingCarousel.remove();

      // Show original images temporarily
      images.forEach(img => {
        img.style.visibility = 'visible';
      });

      // Create new carousel with updated images
      const carousel = document.createElement('div');
      carousel.className = 'product-images-carousel';

      images.forEach(img => {
        carousel.appendChild(img.cloneNode(true));
        img.style.visibility = 'hidden';
      });

      mediaContainer.appendChild(carousel);

      // Reset carousel position
      carousel.style.transform = 'translateX(0%)';

      // Update carousel navigation
      const prevArrow = card.querySelector('.carousel-arrow--prev');
      const nextArrow = card.querySelector('.carousel-arrow--next');

      if (prevArrow && nextArrow) {
        // Remove old event listeners by cloning
        const newPrevArrow = prevArrow.cloneNode(true);
        const newNextArrow = nextArrow.cloneNode(true);
        prevArrow.replaceWith(newPrevArrow);
        nextArrow.replaceWith(newNextArrow);

        let currentIndex = 0;
        const totalImages = carousel.children.length;

        function goToSlide(index) {
          currentIndex = index;
          carousel.style.transform = `translateX(-${currentIndex * 100}%)`;
        }

        newPrevArrow.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const newIndex = (currentIndex - 1 + totalImages) % totalImages;
          goToSlide(newIndex);
        });

        newNextArrow.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const newIndex = (currentIndex + 1) % totalImages;
          goToSlide(newIndex);
        });
      }
    }
  }

  card.querySelectorAll('.card__heading a').forEach(link => {
    if (swatch.dataset.title) link.textContent = swatch.dataset.title;
    if (swatch.dataset.url) link.href = swatch.dataset.url;
  });

  const cardLink = card.querySelector('.card__inner a.link__url');
  if (cardLink && swatch.dataset.url) cardLink.href = swatch.dataset.url;

  const priceContainer = card.querySelector('.price');
  if (priceContainer && swatch.dataset.price) {
    const priceSale = priceContainer.querySelector('.price-item--sale');
    const priceRegular = priceContainer.querySelector('.price-item--regular');

    if (swatch.dataset.comparePrice) {
      if (priceSale) priceSale.textContent = swatch.dataset.price;
      if (priceRegular) priceRegular.textContent = swatch.dataset.comparePrice;
      priceContainer.classList.add('price--on-sale');
    } else {
      if (priceRegular) priceRegular.textContent = swatch.dataset.price;
      priceContainer.classList.remove('price--on-sale');
    }
  }

  if (swatch.dataset.variants) {
    const variants = JSON.parse(swatch.dataset.variants);
    const plpSwatches = card.querySelector('.plp-swatches');
    if (plpSwatches) {
      if (variants.length === 1) {
        plpSwatches.innerHTML = '<button type="button" class="plp-swatch" data-variant-id="' + variants[0].id + '" onclick="updateSelectedVariant(this)">Talla Única</button>';
      } else {
        plpSwatches.innerHTML = variants.map(v =>
          '<button type="button" class="plp-swatch' + (!v.available ? ' disabled' : '') + '" data-variant-id="' + v.id + '" onclick="updateSelectedVariant(this)"' + (!v.available ? ' disabled' : '') + '>' + v.option1 + '</button>'
        ).join('');
      }
    }
  }

  const variantInput = card.querySelector('input.product-variant-id');
  if (variantInput && swatch.dataset.firstVariantId) {
    variantInput.value = swatch.dataset.firstVariantId;
  }

  const quickAddBtn = card.querySelector('.quick-add__submit[data-product-url]');
  if (quickAddBtn && swatch.dataset.url) {
    quickAddBtn.setAttribute('data-product-url', swatch.dataset.url);
  }

  // Update badge dynamically
  const badgeContainer = card.querySelector('.card__badge');
  if (badgeContainer) {
    const available = swatch.dataset.available === 'true';
    const rawPrice = parseInt(swatch.dataset.rawPrice) || 0;
    const rawComparePrice = parseInt(swatch.dataset.rawComparePrice) || 0;

    const existingBadge = badgeContainer.querySelector('span.badge');
    let saleBadgeClasses = 'badge badge--top-left color-accent-1';
    let soldOutBadgeClasses = 'badge badge--bottom-left color-inverse';

    if (existingBadge) {
      if (existingBadge.classList.contains('badge--bottom-left')) {
        soldOutBadgeClasses = existingBadge.className;
      } else {
        saleBadgeClasses = existingBadge.className;
      }
    } else {
      // Determine position from badge container classes
      let badgePosition = 'top-left';
      if (badgeContainer.classList.contains('bottom-left')) badgePosition = 'bottom-left';
      else if (badgeContainer.classList.contains('bottom-right')) badgePosition = 'bottom-right';
      else if (badgeContainer.classList.contains('top-right')) badgePosition = 'top-right';
      else if (badgeContainer.classList.contains('top-left')) badgePosition = 'top-left';
      
      saleBadgeClasses = `badge badge--${badgePosition} color-accent-1`;
    }

    badgeContainer.innerHTML = '';

    if (!available) {
      const badgeSpan = document.createElement('span');
      badgeSpan.className = soldOutBadgeClasses;
      badgeSpan.textContent = window.variantStrings?.soldOut || 'Agotado';
      badgeContainer.appendChild(badgeSpan);
      badgeContainer.style.display = 'block';
    } else if (rawComparePrice > rawPrice) {
      const discountPercentage = Math.round(((rawComparePrice - rawPrice) * 100) / rawComparePrice);
      const badgeSpan = document.createElement('span');
      badgeSpan.className = saleBadgeClasses;
      badgeSpan.textContent = `-${discountPercentage}%`;
      badgeContainer.appendChild(badgeSpan);
      badgeContainer.style.display = 'block';
    } else {
      badgeContainer.style.display = 'none';
    }
  }
}

// Mobile: botón Tallas abre/cierra el bloque de tallas en la card
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.plp-swatches-toggle');
  if (!toggle) return;

  e.preventDefault();
  e.stopPropagation();

  const card = toggle.closest('.card-wrapper');
  if (!card) return;

  const isOpen = card.classList.toggle('plp-swatches-open');
  toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  toggle.setAttribute('aria-label', isOpen ? 'Cerrar tallas' : 'Abrir tallas');

  // Cerrar otras cards abiertas
  document.querySelectorAll('.card-wrapper.plp-swatches-open').forEach(other => {
    if (other === card) return;
    other.classList.remove('plp-swatches-open');
    const btn = other.querySelector('.plp-swatches-toggle');
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Abrir tallas');
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const menus = document.querySelectorAll(".footer-block--menu");

  menus.forEach((menu) => {
    const title = menu.querySelector("h2");

    title.addEventListener("click", () => {
      menus.forEach((m) => {
        if (m !== menu) m.classList.remove("open");
      });

      menu.classList.toggle("open");
    });
  });

  // RaindoorBox

  document.addEventListener('click', function (e) {
    const addButton = e.target.closest('button[name="add"], input[type="submit"][name="add"], .add-to-cart-button', '.plp-add-btn');

    if (addButton) {
      setTimeout(() => {
        if (typeof window.giftSettings !== 'undefined' && window.giftSettings.active) {
          fetch('/cart.js')
            .then(response => response.json())
            .then(cartData => {
              const hasGift = cartData.items.some(item => item.variant_id === window.giftSettings.variantId);

              if (cartData.original_total_price >= window.giftSettings.subtotalMin && !hasGift) {
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: [{ id: window.giftSettings.variantId, quantity: 1 }] })
                }).then(() => {
                  // Trigger cart update event
                  if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'global-gift' });
                  }
                  // Update cart counter
                  fetch('/cart.js')
                    .then(response => response.json())
                    .then(updatedCart => {
                      document.querySelectorAll('[data-cart-count], .cart-count, .header-cart-count').forEach(el => {
                        el.textContent = updatedCart.item_count;
                      });
                    });
                });
              }
            });
        }
      }, 2000);
    }
  });

});



// MENÚ DRAWER - ACORDEÓN CUSTOM
function initMenuDrawerAccordion() {
  const detailsElements = document.querySelectorAll(".menu-drawer details");
  if (!detailsElements.length) return;

  detailsElements.forEach((details) => {
    if (details.dataset.accordionInit) return;
    details.dataset.accordionInit = "true";

    details.addEventListener("toggle", function () {
      const isOpen = this.open;

      if (isOpen) {
        setTimeout(() => {
          if (!details.parentElement.closest("details[open]")) {
            details.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        }, 50);

        detailsElements.forEach((other) => {
          if (other !== details && other.open && !other.contains(details)) {
            other.open = false;
            other.classList.remove("is-open");
          }
        });

        details.classList.add("is-open");
      } else {
        details.classList.remove("is-open");
      }

      void details.offsetHeight;
    });
  });
}

document.addEventListener("DOMContentLoaded", initMenuDrawerAccordion);

document.addEventListener("click", function (e) {
  const drawer = document.querySelector(".menu-drawer");
  if (
    drawer &&
    drawer.classList.contains("menu-drawer--open") &&
    !drawer.contains(e.target) &&
    !e.target.closest("summary")
  ) {
    document.querySelectorAll(".menu-drawer details").forEach((d) => {
      if (d.open) {
        d.open = false;
        d.classList.remove("is-open");
      }
    });
  }
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.querySelector(".menu-drawer")) {
      // Limpiar flags para permitir re-inicialización
      e.target.querySelectorAll(".menu-drawer details").forEach((d) => {
        delete d.dataset.accordionInit;
      });
      initMenuDrawerAccordion();
    }
  });
}

// FIN MENÚ DRAWER - ACORDEÓN CUSTOM



/* MODAL PLP - SELECCIÓN AUTOMÁTICA DE TALLA */
let ultimaTallaClickeada = null;

document.addEventListener("click", function (e) {
  const btn = e.target.closest("button[data-variant-id]");
  if (btn) {
    const titulo = btn.innerText.trim().split("\n")[0];
    ultimaTallaClickeada = titulo;
  }
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "attributes" && mutation.attributeName === "open") {
      const modal = mutation.target;
      if (modal.matches("quick-add-modal") && modal.hasAttribute("open")) {
        setTimeout(() => {
          if (!ultimaTallaClickeada) {
            console.log("No hay talla guardada aún");
            return;
          }

          const variantSelects = modal.querySelector("variant-selects");
          if (!variantSelects) return console.log("No hay variant-selects");

          const input = variantSelects.querySelector(
            `input[type="radio"][value="${ultimaTallaClickeada}"]`
          );
          if (!input) {
            console.log("Talla no encontrada en modal:", ultimaTallaClickeada);
            return;
          }

          input.checked = true;
          input.dispatchEvent(new Event("change", { bubbles: true }));

          console.log("Talla seleccionada en modal:", ultimaTallaClickeada);
        }, 100);
      }
    }
  });
});

document.querySelectorAll("quick-add-modal").forEach((modal) => {
  observer.observe(modal, { attributes: true });
});

new MutationObserver((muts) => {
  muts.forEach((mut) => {
    mut.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.matches?.("quick-add-modal")) {
          observer.observe(node, { attributes: true });
        }
        node.querySelectorAll?.("quick-add-modal")?.forEach((m) => {
          observer.observe(m, { attributes: true });
        });
      }
    });
  });
}).observe(document.body, { childList: true, subtree: true });
/* MODAL PLP - SELECCIÓN AUTOMÁTICA DE TALLA - FIN */

/* MOBILE SWATCHES */
/* FIN MOBILE SWATCHES - Eliminado por redundancia, consolidado al final del archivo */

/* FIN MOBILE SWATCHES */


/* VALIDACIÓN DE BOLSAS DE REGALO + REGLAS DE NEGOCIO */
let isEnforcingGiftRules = false; // Flag to prevent infinite loops during updates
let giftBagValidationTimeout = null; // Debounce para evitar múltiples validaciones

// Helper para deshabilitar checkout durante validaciones
function toggleCheckoutButton(disable) {
  const btn = document.getElementById('CartDrawer-Checkout');
  if (!btn) return;
  if (disable) {
    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('disabled');
  } else {
    btn.removeAttribute('disabled');
    btn.classList.remove('disabled');
  }
}

// Helper para limpiar todos los estados de botones bloqueados en bolsas
function clearAllGiftBagButtonStates() {
  document.querySelectorAll('.cart-item').forEach(cartItem => {
    const plusBtn = cartItem.querySelector('button[name="plus"]');
    if (plusBtn) {
      plusBtn.removeAttribute('disabled');
      plusBtn.classList.remove('disabled');
      plusBtn.style.opacity = '';
      plusBtn.style.pointerEvents = '';
    }
  });
}

function validateAndEnforceGiftBagRules() {
  // Skip if we are currently updating the cart
  if (isEnforcingGiftRules) {
    toggleCheckoutButton(false);
    return;
  }

  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      // Contar bolsas vs otros productos
      let bagCount = 0;
      let otherCount = 0;
      const bagItems = [];
      const bagVariantIds = [];

      cart.items.forEach(item => {
        // Chequear propiedad _is_gift_bag
        if (item.properties && item.properties['_is_gift_bag'] === 'true') {
          bagCount += item.quantity;
          bagItems.push(item);
          if (!bagVariantIds.includes(item.variant_id)) bagVariantIds.push(item.variant_id);
        } else {
          otherCount += item.quantity;
        }
      });

      console.log('GiftBag Logic:', { bagCount, otherCount });

      // --- CASO: No hay bolsas - limpiar estados y habilitar todo ---
      if (bagCount === 0) {
        clearAllGiftBagButtonStates();
        toggleCheckoutButton(false);
        return;
      }

      // --- REGLA 1: Carrito huérfano (Solo bolsas) ---
      if (otherCount === 0 && bagCount > 0) {
        console.log('GiftBag Rules: Solo hay bolsas. Limpiando carrito...');
        isEnforcingGiftRules = true;
        fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' })
          .then(r => r.json())
          .then(updatedCart => {
            console.log('GiftBag Rules: Carrito limpiado via clear.js');
            refreshCartDrawer(updatedCart);
          })
          .finally(() => {
            isEnforcingGiftRules = false;
            toggleCheckoutButton(false);
          });
        return;
      }

      // --- REGLA 2: Exceso de bolsas ---
      if (bagCount > otherCount) {
        let excess = bagCount - otherCount;
        console.log(`GiftBag Rules: Exceso de ${excess} bolsas. Ajustando...`);

        const updates = {};

        // Reducir bolsas hasta eliminar el exceso
        for (const item of bagItems) {
          if (excess <= 0) break;

          if (item.quantity > excess) {
            updates[item.key] = item.quantity - excess;
            excess = 0;
          } else {
            updates[item.key] = 0;
            excess -= item.quantity;
          }
        }

        // FEEDBACK VISUAL: Mostrar spinner en items de bolsa
        bagItems.forEach(item => {
          document.querySelectorAll(`input[data-quantity-variant-id="${item.variant_id}"]`).forEach(input => {
            const cartItem = input.closest('.cart-item');
            if (cartItem) {
              const spinner = cartItem.querySelector('.loading__spinner');
              if (spinner) spinner.classList.remove('hidden');
              cartItem.classList.add('loading');
            }
          });
        });

        isEnforcingGiftRules = true;
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        })
          .then(r => r.json())
          .then(updatedCart => {
            console.log('GiftBag Rules: Carrito ajustado.', updatedCart);
            refreshCartDrawer(updatedCart);
          })
          .finally(() => {
            isEnforcingGiftRules = false;
            toggleCheckoutButton(false);
          });

        return;
      }

      // --- VALIDACIÓN VISUAL: Deshabilitar botón (+) en bolsas si ya hay suficientes ---
      const disablePlus = bagCount >= otherCount;

      bagVariantIds.forEach(id => {
        const quantityInputs = document.querySelectorAll(`input[data-quantity-variant-id="${id}"]`);
        quantityInputs.forEach(input => {
          const wrapper = input.closest('quantity-input') || input.parentElement;
          if (wrapper) {
            const plusBtn = wrapper.querySelector('button[name="plus"]');
            if (plusBtn) {
              if (disablePlus) {
                plusBtn.setAttribute('disabled', 'disabled');
                plusBtn.classList.add('disabled');
                plusBtn.style.opacity = '0.5';
                plusBtn.style.pointerEvents = 'none';
              } else {
                plusBtn.removeAttribute('disabled');
                plusBtn.classList.remove('disabled');
                plusBtn.style.opacity = '';
                plusBtn.style.pointerEvents = '';
              }
            }
          }
        });
      });

      toggleCheckoutButton(false);
    })
    .catch(err => {
      console.error(err);
      isEnforcingGiftRules = false;
      clearAllGiftBagButtonStates();
      toggleCheckoutButton(false);
    });
}

// Versión con debounce para evitar múltiples llamadas seguidas
function debouncedValidateGiftBagRules() {
  if (giftBagValidationTimeout) clearTimeout(giftBagValidationTimeout);
  giftBagValidationTimeout = setTimeout(validateAndEnforceGiftBagRules, 300);
}

/**
 * Refresca los componentes del carrito (drawer, icono) sin recargar la página.
 */
function refreshCartDrawer(cartData) {
  if (cartData && cartData.sections) {
    renderSections(cartData);
  } else {
    fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`)
      .then(r => r.json())
      .then(sections => {
        renderSections({ sections, ...cartData });
      });
  }
}

function renderSections(parsedState) {
  const drawer = document.querySelector('cart-drawer');
  if (drawer && drawer.renderContents) {
    drawer.renderContents(parsedState);
  }

  if (drawer) {
    const isEmpty = parsedState.item_count === 0 || (parsedState.items && parsedState.items.length === 0);
    drawer.classList.toggle('is-empty', isEmpty);
    const inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.toggle('is-empty', isEmpty);
  }

  if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-bag-rule', cart_data: parsedState });
  }

  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedState } }));
}

// Ejecutar al cargar la página (por si es cart page)
document.addEventListener('DOMContentLoaded', validateAndEnforceGiftBagRules);

// Observar cambios en el Cart Drawer
const cartDrawerObserver = new MutationObserver((mutations) => {
  let shouldRun = false;
  mutations.forEach(m => {
    if (m.addedNodes.length > 0) shouldRun = true;
  });

  if (shouldRun) {
    debouncedValidateGiftBagRules();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const targetNodes = [
    document.getElementById('CartDrawer'),
    document.querySelector('cart-drawer-items'),
    document.querySelector('.cart-drawer__items'),
    document.querySelector('#main-cart-items')
  ];

  targetNodes.forEach(node => {
    if (node) {
      cartDrawerObserver.observe(node, { childList: true, subtree: true });
    }
  });
});

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, debouncedValidateGiftBagRules);
}
/* FIN VALIDACIÓN DE BOLSAS DE REGALO */

(function () {
  if (!('ontouchstart' in window) || window.innerWidth > 1024) return;

  const DELAY_DEFAULT = 800;
  const DELAY_INTERACTION = 2000;
  const SELECTORS = {
    card: '.card-wrapper',
    swatches: '.plp-swatches-wrapper',
    arrow: '.carousel-arrow',
    link: '.link__url',
    ignore: '.plp-add-btn, .quick-add__submit'
  };

  let timer = null;
  let active = null;
  let userInteracting = false;

  const deactivate = () => {
    clearTimeout(timer);
    if (active) {
      active.classList.remove('carousel-active');
      const sw = active.querySelector(SELECTORS.swatches);
      if (sw) sw.classList.remove('active');
      active = null;
    }
    userInteracting = false;
  };

  const schedule = (delay) => {
    clearTimeout(timer);
    timer = setTimeout(deactivate, delay);
  };

  const isInteractiveElement = (target) =>
    target.closest(SELECTORS.swatches) || target.closest(SELECTORS.arrow);

  const getIsBottomPart = (element, clientY) => {
    const rect = element.getBoundingClientRect();
    const touchYRelative = (clientY - rect.top) / rect.height;
    return touchYRelative >= 0.20; // 20% superior para navegación, 80% inferior para tallas
  };

  document.addEventListener('touchstart', (e) => {
    const card = e.target.closest(SELECTORS.card);
    if (!card) {
      if (!isInteractiveElement(e.target)) deactivate();
      return;
    }

    if (isInteractiveElement(e.target)) {
      userInteracting = true;
      schedule(DELAY_INTERACTION);
      return;
    }

    const touch = e.touches[0];
    const isBottom = getIsBottomPart(card, touch.clientY);

    if (isBottom) {
      // Mitad inferior: Activar tallas inmediatamente
      if (active && active !== card) deactivate();
      active = card;
      card.classList.add('carousel-active');
      const sw = card.querySelector(SELECTORS.swatches);
      if (sw) sw.classList.add('active');
      userInteracting = false;
      schedule(DELAY_DEFAULT);

      // Prevenimos el click del link de abajo para que no navegue por error al intentar ver tallas
      const blockNav = (ev) => {
        ev.preventDefault();
        document.removeEventListener('click', blockNav, true);
      };
      document.addEventListener('click', blockNav, true);
      setTimeout(() => document.removeEventListener('click', blockNav, true), 300);
    } else {
      // Mitad superior: Desactivar tallas si estaban abiertas y dejar que el click nativo navegue
      deactivate();
    }
  }, { passive: false });

  document.addEventListener('touchend', (e) => {
    if (e.target.closest(SELECTORS.ignore)) return;
    if (isInteractiveElement(e.target)) return;

    const card = e.target.closest(SELECTORS.card);
    if (!card) return;

    const touch = e.changedTouches[0];
    const isBottom = getIsBottomPart(card, touch.clientY);

    // Si soltó arriba, forzamos la navegación para asegurar el "1 solo click"
    if (!isBottom) {
      const href = card.querySelector(SELECTORS.link)?.href || card.querySelector('a')?.href;
      if (href) window.location.href = href;
    }
  }, { passive: true });

  document.addEventListener('click', (e) => {
    const card = e.target.closest(SELECTORS.card);
    if (!card || isInteractiveElement(e.target)) return;

    const isBottom = getIsBottomPart(card, e.clientY);
    if (isBottom && active === card) {
      // Allow interaction with swatches
    }
  }, true);
})();

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 1024) {
    initMobileCarousel();
  }
  // initMegaMenuPromoDrag(); // replaced by megamenu-fix.js
  // initMegaMenuHover(); // Function not defined
});

function initMobileCarousel() {
  const cardWrappers = document.querySelectorAll('.card-wrapper');

  cardWrappers.forEach(cardWrapper => {
    const cardInner = cardWrapper.querySelector('.card__inner');
    const mediaContainer = cardInner ? cardInner.querySelector('.media') : null;
    const prevArrow = cardWrapper.querySelector('.carousel-arrow--prev');
    const nextArrow = cardWrapper.querySelector('.carousel-arrow--next');

    if (!prevArrow || !nextArrow || !mediaContainer) return;

    const images = mediaContainer.querySelectorAll('img');
    if (images.length <= 1) return;

    const carousel = document.createElement('div');
    carousel.className = 'product-images-carousel';

    images.forEach(img => {
      carousel.appendChild(img.cloneNode(true));
      img.style.visibility = 'hidden';
    });

    mediaContainer.appendChild(carousel);

    let currentIndex = 0;
    const totalImages = carousel.children.length;

    function goToSlide(index) {
      currentIndex = index;
      carousel.style.transform = `translateX(-${currentIndex * 100}%)`;
    }

    prevArrow.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = (currentIndex - 1 + totalImages) % totalImages;
      goToSlide(newIndex);
    });

    nextArrow.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = (currentIndex + 1) % totalImages;
      goToSlide(newIndex);
    });
  });
}

function initMegaMenuPromoDrag() {
  const promoRows = document.querySelectorAll('.mega-menu__promo');
  if (!promoRows.length) return;

  promoRows.forEach((promoRow) => {
    let isDown = false;
    let hasDragged = false;
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let scrollLeft = 0;
    let pointerId = null;

    const startPointer = (clientX, clientY) => {
      isDown = true;
      hasDragged = false;
      isDragging = false;
      startX = clientX;
      startY = clientY;
      scrollLeft = promoRow.scrollLeft;
      promoRow.classList.add('is-dragging');
    };

    const stopPointer = () => {
      if (!isDown) return;
      isDown = false;
      isDragging = false;
      promoRow.classList.remove('is-dragging');
      setTimeout(() => { hasDragged = false; }, 0);
    };

    const movePointer = (clientX, clientY, event) => {
      if (!isDown) return;

      const dx = clientX - startX;
      const dy = clientY - startY;

      if (!isDragging) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        if (Math.abs(dx) <= Math.abs(dy)) {
          stopPointer();
          return;
        }
        isDragging = true;
      }

      hasDragged = true;
      promoRow.scrollLeft = scrollLeft - dx;

      if (event && event.cancelable) {
        event.preventDefault();
      }
    };

    const onClick = (event) => {
      if (!hasDragged) return;
      event.preventDefault();
      event.stopPropagation();
    };

    const onPointerDown = (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      promoRow.setPointerCapture(pointerId);
      startPointer(event.clientX, event.clientY);
    };

    const onPointerMove = (event) => {
      if (!isDown || event.pointerId !== pointerId) return;
      movePointer(event.clientX, event.clientY, event);
    };

    const onPointerEnd = (event) => {
      if (!isDown || event.pointerId !== pointerId) return;
      stopPointer();
      if (promoRow.hasPointerCapture(pointerId)) {
        promoRow.releasePointerCapture(pointerId);
      }
    };

    if (window.PointerEvent) {
      promoRow.addEventListener('pointerdown', onPointerDown);
      promoRow.addEventListener('pointermove', onPointerMove, { passive: false });
      promoRow.addEventListener('pointerup', onPointerEnd);
      promoRow.addEventListener('pointercancel', onPointerEnd);
    } else {
      promoRow.addEventListener('mousedown', (event) => {
        if (event.button !== 0) return;
        startPointer(event.clientX, event.clientY);
      });
      promoRow.addEventListener('mousemove', (event) => {
        if (!isDown) return;
        movePointer(event.clientX, event.clientY, event);
      });
      promoRow.addEventListener('mouseleave', stopPointer);
      promoRow.addEventListener('mouseup', stopPointer);
      promoRow.addEventListener('touchstart', (event) => {
        if (event.touches.length > 1) return;
        const touch = event.touches[0];
        startPointer(touch.clientX, touch.clientY);
      }, { passive: true });
      promoRow.addEventListener('touchmove', (event) => {
        if (!isDown) return;
        const touch = event.touches[0];
        movePointer(touch.clientX, touch.clientY, event);
      }, { passive: false });
      promoRow.addEventListener('touchend', stopPointer);
      promoRow.addEventListener('touchcancel', stopPointer);
    }

    promoRow.addEventListener('click', onClick, true);
  });
}

/* ========================================
   GIFT BAG CART DRAWER FUNCTIONALITY
   ======================================== */

(function () {
  let isProcessing = false;

  function initGiftBagItems() {
    const wrappers = document.querySelectorAll('.gift-bag-item-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      // Skip if already initialized
      if (wrapper.dataset.initialized === 'true') return;
      wrapper.dataset.initialized = 'true';

      const checkbox = wrapper.querySelector('.gift-bag-item-input');
      const selectionArea = wrapper.querySelector('.gift-bag-item-selection');
      const priceLabel = wrapper.querySelector('.gift-bag-item-price-label');
      const options = wrapper.querySelectorAll('.gift-item-option');
      const itemKey = wrapper.dataset.itemKey;

      if (!checkbox || !options.length) return;

      // Update price label based on selected option
      function updatePriceLabel() {
        const selected = wrapper.querySelector('.gift-item-option.selected');
        if (selected && priceLabel) {
          priceLabel.textContent = selected.dataset.formattedPrice;
        }
      }

      // Get selected variant ID
      function getSelectedVariantId() {
        const selected = wrapper.querySelector('.gift-item-option.selected');
        return selected ? selected.dataset.variantId : null;
      }

      // Select an option visually
      function selectOption(el) {
        options.forEach(opt => opt.classList.remove('selected'));
        el.classList.add('selected');
        updatePriceLabel();
      }

      // Initialize price label
      updatePriceLabel();

      // Check if a gift bag already exists for this item in the cart
      async function checkExistingGiftBag() {
        try {
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();

          const existingGift = cartData.items.find(item =>
            item.properties &&
            item.properties['_is_gift_bag'] === 'true' &&
            item.properties['_gift_for_item'] === itemKey
          );

          if (existingGift) {
            // Gift bag exists - check the checkbox and show selection
            checkbox.checked = true;
            selectionArea.style.display = 'flex';

            // Select the matching variant option
            const matchingOption = Array.from(options).find(
              opt => opt.dataset.variantId === String(existingGift.variant_id)
            );

            if (matchingOption) {
              selectOption(matchingOption);
            }
          }
        } catch (err) {
          console.error('Error checking existing gift bag:', err);
        }
      }

      // Initialize state based on cart
      checkExistingGiftBag();

      // Remove gift bag for this specific item
      async function removeGiftForItem() {
        try {
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();

          const giftItem = cartData.items.find(item =>
            item.properties &&
            item.properties['_is_gift_bag'] === 'true' &&
            item.properties['_gift_for_item'] === itemKey
          );

          if (giftItem) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: giftItem.key,
                quantity: 0
              })
            });
            return true;
          }
          return false;
        } catch (err) {
          console.error('Error removing gift bag:', err);
          return false;
        }
      }

      // Add gift bag for this specific item
      async function addGiftForItem(variantId) {
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                '_is_gift_bag': 'true',
                '_gift_for_item': itemKey
              }
            })
          });
          return true;
        } catch (err) {
          console.error('Error adding gift bag:', err);
          return false;
        }
      }

      // Refresh cart drawer content
      function refreshCartDrawer() {
        fetch('/cart?sections=cart-drawer')
          .then(res => res.json())
          .then(data => {
            if (data['cart-drawer']) {
              const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
              const newContent = html.querySelector('cart-drawer');
              const currentDrawer = document.querySelector('cart-drawer');

              if (newContent && currentDrawer) {
                currentDrawer.innerHTML = newContent.innerHTML;
                // Re-initialize after DOM update
                setTimeout(() => {
                  initGiftBagItems();
                  isProcessing = false;
                }, 100);
              }
            }
          })
          .catch(err => {
            console.error('Error refreshing cart:', err);
            isProcessing = false;
          });
      }

      // Checkbox change handler
      checkbox.addEventListener('change', async function (e) {
        if (isProcessing) {
          this.checked = !this.checked;
          return;
        }

        isProcessing = true;
        wrapper.classList.add('updating');

        if (this.checked) {
          selectionArea.style.display = 'flex';
          const variantId = getSelectedVariantId();

          if (variantId) {
            await removeGiftForItem();
            await addGiftForItem(variantId);
            refreshCartDrawer();
          } else {
            isProcessing = false;
            wrapper.classList.remove('updating');
          }
        } else {
          selectionArea.style.display = 'none';
          const removed = await removeGiftForItem();
          if (removed) {
            refreshCartDrawer();
          } else {
            isProcessing = false;
            wrapper.classList.remove('updating');
          }
        }
      });

      // Option click handler
      options.forEach(opt => {
        opt.addEventListener('click', async function () {
          if (isProcessing || this.classList.contains('selected')) {
            return;
          }

          isProcessing = true;

          // Update visual state immediately
          selectOption(this);

          // Only update cart if checkbox is checked
          if (checkbox.checked) {
            const newVariantId = this.dataset.variantId;

            // Update cart and refresh to show the new gift bag
            await removeGiftForItem();
            await addGiftForItem(newVariantId);

            // Refresh the drawer to show the updated gift bag
            refreshCartDrawer();
          } else {
            isProcessing = false;
          }
        });
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftBagItems);
  } else {
    initGiftBagItems();
  }

  // Watch for cart drawer content changes (when drawer opens or updates)
  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;

    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        // Check if any added nodes contain gift bag wrappers
        const hasGiftBag = Array.from(mutation.addedNodes).some(node => {
          if (node.nodeType === 1) {
            return node.classList?.contains('gift-bag-item-wrapper') ||
              node.querySelector?.('.gift-bag-item-wrapper');
          }
          return false;
        });

        if (hasGiftBag) {
          shouldInit = true;
          break;
        }
      }
    }

    if (shouldInit) {
      setTimeout(initGiftBagItems, 100);
    }
  });

  // Start observing the cart drawer
  const startObserving = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
      initGiftBagItems();
    } else {
      setTimeout(startObserving, 500);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  // Listen for Shopify cart update events
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(initGiftBagItems, 200);
    });
  }

  // Listen for custom cart updated events
  document.addEventListener('cart:updated', () => {
    setTimeout(initGiftBagItems, 200);
  });

  // Fallback: Check periodically when cart drawer is open
  setInterval(() => {
    const cartDrawer = document.querySelector('cart-drawer');
    const isOpen = cartDrawer?.classList.contains('active') || cartDrawer?.hasAttribute('open');

    if (isOpen) {
      const wrappers = document.querySelectorAll('.gift-bag-item-wrapper');
      const uninitializedWrappers = Array.from(wrappers).filter(w => w.dataset.initialized !== 'true');

      if (uninitializedWrappers.length > 0) {
        initGiftBagItems();
      }
    }
  }, 500);

  // Expose for re-initialization
  window.initGiftBagItems = initGiftBagItems;
})();
